package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings10 {
  internal val search_suggestions_fill_field: StringResource by lazy {
      init_search_suggestions_fill_field() }

  internal val search_suggestions_more: StringResource by lazy { init_search_suggestions_more() }

  internal val search_suggestions_page_results: StringResource by lazy {
      init_search_suggestions_page_results() }

  internal val search_suggestions_personal: StringResource by lazy {
      init_search_suggestions_personal() }

  internal val search_suggestions_popular: StringResource by lazy {
      init_search_suggestions_popular() }

  internal val search_suggestions_this_month: StringResource by lazy {
      init_search_suggestions_this_month() }

  internal val search_suggestions_this_week: StringResource by lazy {
      init_search_suggestions_this_week() }

  internal val search_summary_books_format: StringResource by lazy {
      init_search_summary_books_format() }

  internal val search_summary_format: StringResource by lazy { init_search_summary_format() }

  internal val search_summary_one_book: StringResource by lazy { init_search_summary_one_book() }

  internal val search_termination_format: StringResource by lazy { init_search_termination_format()
      }

  internal val search_try_suggestion: StringResource by lazy { init_search_try_suggestion() }

  internal val search_upgrade_message: StringResource by lazy { init_search_upgrade_message() }

  internal val searched_expression: StringResource by lazy { init_searched_expression() }

  internal val searched_expression_results: StringResource by lazy {
      init_searched_expression_results() }

  internal val searched_expression_results_format: StringResource by lazy {
      init_searched_expression_results_format() }

  internal val searching_date: StringResource by lazy { init_searching_date() }

  internal val searching_number: StringResource by lazy { init_searching_number() }

  internal val searching_root: StringResource by lazy { init_searching_root() }

  internal val sedarim: StringResource by lazy { init_sedarim() }

  internal val seder_str: StringResource by lazy { init_seder_str() }

  internal val seder_str_placeholder: StringResource by lazy { init_seder_str_placeholder() }

  internal val seder_str_placeholder_no_name: StringResource by lazy {
      init_seder_str_placeholder_no_name() }

  internal val sefer: StringResource by lazy { init_sefer() }

  internal val select_all: StringResource by lazy { init_select_all() }

  internal val select_all_text: StringResource by lazy { init_select_all_text() }

  internal val seminar_game_bible_contest: StringResource by lazy {
      init_seminar_game_bible_contest() }

  internal val send_anonymous_usage_stats: StringResource by lazy {
      init_send_anonymous_usage_stats() }

  internal val server: StringResource by lazy { init_server() }

  internal val several_random_verses: StringResource by lazy { init_several_random_verses() }

  internal val seyfot: StringResource by lazy { init_seyfot() }

  internal val shabbat: StringResource by lazy { init_shabbat() }

  internal val shake: StringResource by lazy { init_shake() }

  internal val share: StringResource by lazy { init_share() }

  internal val share_app_name: StringResource by lazy { init_share_app_name() }

  internal val share_search: StringResource by lazy { init_share_search() }

  internal val sharing: StringResource by lazy { init_sharing() }

  internal val shmot_onqelos: StringResource by lazy { init_shmot_onqelos() }

  internal val shnaim_mikra_veechad_targum: StringResource by lazy {
      init_shnaim_mikra_veechad_targum() }

  internal val show: StringResource by lazy { init_show() }

  internal val show_beginning_of_verse: StringResource by lazy { init_show_beginning_of_verse() }

  internal val show_chapter: StringResource by lazy { init_show_chapter() }

  internal val show_end_of_verse: StringResource by lazy { init_show_end_of_verse() }

  internal val show_full_chapter: StringResource by lazy { init_show_full_chapter() }

  internal val show_full_pasuk: StringResource by lazy { init_show_full_pasuk() }

  internal val show_hide_signs_placeholder: StringResource by lazy {
      init_show_hide_signs_placeholder() }

  internal val show_mikud: StringResource by lazy { init_show_mikud() }

  internal val show_nikud: StringResource by lazy { init_show_nikud() }

  internal val show_table_books: StringResource by lazy { init_show_table_books() }

  internal val show_table_chapters: StringResource by lazy { init_show_table_chapters() }

  internal fun values(): List<StringResource> = listOf(search_suggestions_fill_field,
      search_suggestions_more, search_suggestions_page_results, search_suggestions_personal,
      search_suggestions_popular, search_suggestions_this_month, search_suggestions_this_week,
      search_summary_books_format, search_summary_format, search_summary_one_book,
      search_termination_format, search_try_suggestion, search_upgrade_message, searched_expression,
      searched_expression_results, searched_expression_results_format, searching_date,
      searching_number, searching_root, sedarim, seder_str, seder_str_placeholder,
      seder_str_placeholder_no_name, sefer, select_all, select_all_text, seminar_game_bible_contest,
      send_anonymous_usage_stats, server, several_random_verses, seyfot, shabbat, shake, share,
      share_app_name, share_search, sharing, shmot_onqelos, shnaim_mikra_veechad_targum, show,
      show_beginning_of_verse, show_chapter, show_end_of_verse, show_full_chapter, show_full_pasuk,
      show_hide_signs_placeholder, show_mikud, show_nikud, show_table_books, show_table_chapters)
}

private fun init_search_suggestions_fill_field(): StringResource = StringResource(key =
    "search_suggestions_fill_field", loader = stringsLoader)

private fun init_search_suggestions_more(): StringResource = StringResource(key =
    "search_suggestions_more", loader = stringsLoader)

private fun init_search_suggestions_page_results(): StringResource = StringResource(key =
    "search_suggestions_page_results", loader = stringsLoader)

private fun init_search_suggestions_personal(): StringResource = StringResource(key =
    "search_suggestions_personal", loader = stringsLoader)

private fun init_search_suggestions_popular(): StringResource = StringResource(key =
    "search_suggestions_popular", loader = stringsLoader)

private fun init_search_suggestions_this_month(): StringResource = StringResource(key =
    "search_suggestions_this_month", loader = stringsLoader)

private fun init_search_suggestions_this_week(): StringResource = StringResource(key =
    "search_suggestions_this_week", loader = stringsLoader)

private fun init_search_summary_books_format(): StringResource = StringResource(key =
    "search_summary_books_format", loader = stringsLoader)

private fun init_search_summary_format(): StringResource = StringResource(key =
    "search_summary_format", loader = stringsLoader)

private fun init_search_summary_one_book(): StringResource = StringResource(key =
    "search_summary_one_book", loader = stringsLoader)

private fun init_search_termination_format(): StringResource = StringResource(key =
    "search_termination_format", loader = stringsLoader)

private fun init_search_try_suggestion(): StringResource = StringResource(key =
    "search_try_suggestion", loader = stringsLoader)

private fun init_search_upgrade_message(): StringResource = StringResource(key =
    "search_upgrade_message", loader = stringsLoader)

private fun init_searched_expression(): StringResource = StringResource(key = "searched_expression",
    loader = stringsLoader)

private fun init_searched_expression_results(): StringResource = StringResource(key =
    "searched_expression_results", loader = stringsLoader)

private fun init_searched_expression_results_format(): StringResource = StringResource(key =
    "searched_expression_results_format", loader = stringsLoader)

private fun init_searching_date(): StringResource = StringResource(key = "searching_date", loader =
    stringsLoader)

private fun init_searching_number(): StringResource = StringResource(key = "searching_number",
    loader = stringsLoader)

private fun init_searching_root(): StringResource = StringResource(key = "searching_root", loader =
    stringsLoader)

private fun init_sedarim(): StringResource = StringResource(key = "sedarim", loader = stringsLoader)

private fun init_seder_str(): StringResource = StringResource(key = "seder_str", loader =
    stringsLoader)

private fun init_seder_str_placeholder(): StringResource = StringResource(key =
    "seder_str_placeholder", loader = stringsLoader)

private fun init_seder_str_placeholder_no_name(): StringResource = StringResource(key =
    "seder_str_placeholder_no_name", loader = stringsLoader)

private fun init_sefer(): StringResource = StringResource(key = "sefer", loader = stringsLoader)

private fun init_select_all(): StringResource = StringResource(key = "select_all", loader =
    stringsLoader)

private fun init_select_all_text(): StringResource = StringResource(key = "select_all_text", loader
    = stringsLoader)

private fun init_seminar_game_bible_contest(): StringResource = StringResource(key =
    "seminar_game_bible_contest", loader = stringsLoader)

private fun init_send_anonymous_usage_stats(): StringResource = StringResource(key =
    "send_anonymous_usage_stats", loader = stringsLoader)

private fun init_server(): StringResource = StringResource(key = "server", loader = stringsLoader)

private fun init_several_random_verses(): StringResource = StringResource(key =
    "several_random_verses", loader = stringsLoader)

private fun init_seyfot(): StringResource = StringResource(key = "seyfot", loader = stringsLoader)

private fun init_shabbat(): StringResource = StringResource(key = "shabbat", loader = stringsLoader)

private fun init_shake(): StringResource = StringResource(key = "shake", loader = stringsLoader)

private fun init_share(): StringResource = StringResource(key = "share", loader = stringsLoader)

private fun init_share_app_name(): StringResource = StringResource(key = "share_app_name", loader =
    stringsLoader)

private fun init_share_search(): StringResource = StringResource(key = "share_search", loader =
    stringsLoader)

private fun init_sharing(): StringResource = StringResource(key = "sharing", loader = stringsLoader)

private fun init_shmot_onqelos(): StringResource = StringResource(key = "shmot_onqelos", loader =
    stringsLoader)

private fun init_shnaim_mikra_veechad_targum(): StringResource = StringResource(key =
    "shnaim_mikra_veechad_targum", loader = stringsLoader)

private fun init_show(): StringResource = StringResource(key = "show", loader = stringsLoader)

private fun init_show_beginning_of_verse(): StringResource = StringResource(key =
    "show_beginning_of_verse", loader = stringsLoader)

private fun init_show_chapter(): StringResource = StringResource(key = "show_chapter", loader =
    stringsLoader)

private fun init_show_end_of_verse(): StringResource = StringResource(key = "show_end_of_verse",
    loader = stringsLoader)

private fun init_show_full_chapter(): StringResource = StringResource(key = "show_full_chapter",
    loader = stringsLoader)

private fun init_show_full_pasuk(): StringResource = StringResource(key = "show_full_pasuk", loader
    = stringsLoader)

private fun init_show_hide_signs_placeholder(): StringResource = StringResource(key =
    "show_hide_signs_placeholder", loader = stringsLoader)

private fun init_show_mikud(): StringResource = StringResource(key = "show_mikud", loader =
    stringsLoader)

private fun init_show_nikud(): StringResource = StringResource(key = "show_nikud", loader =
    stringsLoader)

private fun init_show_table_books(): StringResource = StringResource(key = "show_table_books",
    loader = stringsLoader)

private fun init_show_table_chapters(): StringResource = StringResource(key = "show_table_chapters",
    loader = stringsLoader)

public actual val SharedRes.strings.search_suggestions_fill_field: StringResource
  get() = CommonMainStrings10.search_suggestions_fill_field

public actual val SharedRes.strings.search_suggestions_more: StringResource
  get() = CommonMainStrings10.search_suggestions_more

public actual val SharedRes.strings.search_suggestions_page_results: StringResource
  get() = CommonMainStrings10.search_suggestions_page_results

public actual val SharedRes.strings.search_suggestions_personal: StringResource
  get() = CommonMainStrings10.search_suggestions_personal

public actual val SharedRes.strings.search_suggestions_popular: StringResource
  get() = CommonMainStrings10.search_suggestions_popular

public actual val SharedRes.strings.search_suggestions_this_month: StringResource
  get() = CommonMainStrings10.search_suggestions_this_month

public actual val SharedRes.strings.search_suggestions_this_week: StringResource
  get() = CommonMainStrings10.search_suggestions_this_week

public actual val SharedRes.strings.search_summary_books_format: StringResource
  get() = CommonMainStrings10.search_summary_books_format

public actual val SharedRes.strings.search_summary_format: StringResource
  get() = CommonMainStrings10.search_summary_format

public actual val SharedRes.strings.search_summary_one_book: StringResource
  get() = CommonMainStrings10.search_summary_one_book

public actual val SharedRes.strings.search_termination_format: StringResource
  get() = CommonMainStrings10.search_termination_format

public actual val SharedRes.strings.search_try_suggestion: StringResource
  get() = CommonMainStrings10.search_try_suggestion

public actual val SharedRes.strings.search_upgrade_message: StringResource
  get() = CommonMainStrings10.search_upgrade_message

public actual val SharedRes.strings.searched_expression: StringResource
  get() = CommonMainStrings10.searched_expression

public actual val SharedRes.strings.searched_expression_results: StringResource
  get() = CommonMainStrings10.searched_expression_results

public actual val SharedRes.strings.searched_expression_results_format: StringResource
  get() = CommonMainStrings10.searched_expression_results_format

public actual val SharedRes.strings.searching_date: StringResource
  get() = CommonMainStrings10.searching_date

public actual val SharedRes.strings.searching_number: StringResource
  get() = CommonMainStrings10.searching_number

public actual val SharedRes.strings.searching_root: StringResource
  get() = CommonMainStrings10.searching_root

public actual val SharedRes.strings.sedarim: StringResource
  get() = CommonMainStrings10.sedarim

public actual val SharedRes.strings.seder_str: StringResource
  get() = CommonMainStrings10.seder_str

public actual val SharedRes.strings.seder_str_placeholder: StringResource
  get() = CommonMainStrings10.seder_str_placeholder

public actual val SharedRes.strings.seder_str_placeholder_no_name: StringResource
  get() = CommonMainStrings10.seder_str_placeholder_no_name

public actual val SharedRes.strings.sefer: StringResource
  get() = CommonMainStrings10.sefer

public actual val SharedRes.strings.select_all: StringResource
  get() = CommonMainStrings10.select_all

public actual val SharedRes.strings.select_all_text: StringResource
  get() = CommonMainStrings10.select_all_text

public actual val SharedRes.strings.seminar_game_bible_contest: StringResource
  get() = CommonMainStrings10.seminar_game_bible_contest

public actual val SharedRes.strings.send_anonymous_usage_stats: StringResource
  get() = CommonMainStrings10.send_anonymous_usage_stats

public actual val SharedRes.strings.server: StringResource
  get() = CommonMainStrings10.server

public actual val SharedRes.strings.several_random_verses: StringResource
  get() = CommonMainStrings10.several_random_verses

public actual val SharedRes.strings.seyfot: StringResource
  get() = CommonMainStrings10.seyfot

public actual val SharedRes.strings.shabbat: StringResource
  get() = CommonMainStrings10.shabbat

public actual val SharedRes.strings.shake: StringResource
  get() = CommonMainStrings10.shake

public actual val SharedRes.strings.share: StringResource
  get() = CommonMainStrings10.share

public actual val SharedRes.strings.share_app_name: StringResource
  get() = CommonMainStrings10.share_app_name

public actual val SharedRes.strings.share_search: StringResource
  get() = CommonMainStrings10.share_search

public actual val SharedRes.strings.sharing: StringResource
  get() = CommonMainStrings10.sharing

public actual val SharedRes.strings.shmot_onqelos: StringResource
  get() = CommonMainStrings10.shmot_onqelos

public actual val SharedRes.strings.shnaim_mikra_veechad_targum: StringResource
  get() = CommonMainStrings10.shnaim_mikra_veechad_targum

public actual val SharedRes.strings.show: StringResource
  get() = CommonMainStrings10.show

public actual val SharedRes.strings.show_beginning_of_verse: StringResource
  get() = CommonMainStrings10.show_beginning_of_verse

public actual val SharedRes.strings.show_chapter: StringResource
  get() = CommonMainStrings10.show_chapter

public actual val SharedRes.strings.show_end_of_verse: StringResource
  get() = CommonMainStrings10.show_end_of_verse

public actual val SharedRes.strings.show_full_chapter: StringResource
  get() = CommonMainStrings10.show_full_chapter

public actual val SharedRes.strings.show_full_pasuk: StringResource
  get() = CommonMainStrings10.show_full_pasuk

public actual val SharedRes.strings.show_hide_signs_placeholder: StringResource
  get() = CommonMainStrings10.show_hide_signs_placeholder

public actual val SharedRes.strings.show_mikud: StringResource
  get() = CommonMainStrings10.show_mikud

public actual val SharedRes.strings.show_nikud: StringResource
  get() = CommonMainStrings10.show_nikud

public actual val SharedRes.strings.show_table_books: StringResource
  get() = CommonMainStrings10.show_table_books

public actual val SharedRes.strings.show_table_chapters: StringResource
  get() = CommonMainStrings10.show_table_chapters
